angular.module('unica_location.location_services')

.factory('LocationEditService', function ($http, getBaseApiURL) {

	var locationEditService = {};

	locationEditService.update = function (locationData)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/location/update/' + locationData.id,
			data: locationData
		}).then(function(result) {

			if ( result ) {
				return result.data.location;
			}

		});
	};

	return locationEditService;
});